module.exports = __webpack_public_path__ + "img/2.7f2df1d0.jpg";